import { render, staticRenderFns } from "./Bought.vue?vue&type=template&id=5da0fe2d&"
import script from "./Bought.vue?vue&type=script&lang=js&"
export * from "./Bought.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports